
const DashboardPage = () => (
  <div className="p-8">
    <h1 className="text-2xl font-bold mb-6">Yönetim Paneli</h1>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      <div className="bg-white rounded-xl shadow-md p-4">
        <div className="text-sm text-gray-500">Toplam Ürün</div>
        <div className="text-2xl font-semibold">1280</div>
      </div>
      <div className="bg-white rounded-xl shadow-md p-4">
        <div className="text-sm text-gray-500">Toplam Kullanıcı</div>
        <div className="text-2xl font-semibold">742</div>
      </div>
      <div className="bg-white rounded-xl shadow-md p-4">
        <div className="text-sm text-gray-500">Aktif Kampanya</div>
        <div className="text-2xl font-semibold">5</div>
      </div>
      <div className="bg-white rounded-xl shadow-md p-4">
        <div className="text-sm text-gray-500">Bekleyen Sipariş</div>
        <div className="text-2xl font-semibold">23</div>
      </div>
    </div>

    <div className="bg-white rounded-xl shadow-md p-6">
      <h2 className="text-lg font-semibold mb-4">Son Siparişler</h2>
      <table className="w-full text-sm text-left">
        <thead>
          <tr className="text-gray-600 border-b">
            <th className="py-2">Sipariş ID</th>
            <th className="py-2">Kullanıcı</th>
            <th className="py-2">Tarih</th>
            <th className="py-2">Toplam</th>
            <th className="py-2">Durum</th>
          </tr>
        </thead>
        <tbody>
          <tr className="border-b hover:bg-gray-50">
            <td className="py-2">#1001</td>
            <td className="py-2">Ayşe Yılmaz</td>
            <td className="py-2">2025-06-14</td>
            <td className="py-2">₺1.200</td>
            <td className="py-2 text-green-600 font-medium">Onaylandı</td>
          </tr>
          <tr className="border-b hover:bg-gray-50">
            <td className="py-2">#1000</td>
            <td className="py-2">Mehmet Demir</td>
            <td className="py-2">2025-06-13</td>
            <td className="py-2">₺850</td>
            <td className="py-2 text-yellow-600 font-medium">Bekliyor</td>
          </tr>
          <tr className="hover:bg-gray-50">
            <td className="py-2">#0999</td>
            <td className="py-2">Zeynep Koç</td>
            <td className="py-2">2025-06-12</td>
            <td className="py-2">₺2.320</td>
            <td className="py-2 text-red-600 font-medium">İptal</td>
          </tr>
        </tbody>
      </table>
    </div>
    {/* <div className="space-y-4">
      <div>
        <Link to="/admin/products" className="text-blue-600 hover:underline text-lg">
          Ürün Yönetimi
        </Link>
      </div>
      <div>
        <Link to="/admin/orders" className="text-blue-600 hover:underline text-lg">
          Sipariş Yönetimi
        </Link>
      </div>
      <div>
        <Link to="/admin/campaigns" className="text-blue-600 hover:underline text-lg">
          Kampanya Yönetimi
        </Link>
      </div>
    </div> */}
  </div>
);

export default DashboardPage;